import React from "react";
import { FormControl, InputLabel, Select as MuiSelect, MenuItem, FormHelperText } from "@mui/material";

// Observações:
// - defaultValue, textAttribute, valueAttribute, onChange, value, label, arrayOptions  são necessários
// -
// eslint-disable-next-line
export function Select({
  label,
  value,
  onChange,
  arrayOptions = [],
  valueAttribute,
  textAttribute,
  required,
  error,
  helperText,
  ...rest
}) {

  const labelAsterisco = required && label ? (
    <>
      {label} <span style={{ color: '#666666' }}>*</span>
    </>
  ) : label;
  
  const labelString = required && label ? `${label} *` : label;
  
  return (
    <FormControl fullWidth error={error}>
      <InputLabel 
        required={false}
        {...rest}
      >
        {labelAsterisco}
      </InputLabel>
      <MuiSelect
        required={required}
        onChange={onChange}
        value={value}
        label={labelString}
        {...rest}
      >
        {arrayOptions.map(item =>
          valueAttribute && textAttribute ? (
            <MenuItem key={item[valueAttribute]} value={item[valueAttribute]}>
              {item[textAttribute]}
            </MenuItem>
          ) : (
            <MenuItem key={item} value={item}>
              {item}
            </MenuItem>
          )
        )}
      </MuiSelect>
      {helperText && <FormHelperText sx={{ margin: 0, marginTop: '3px' }}>{helperText}</FormHelperText>}
    </FormControl>
  );
}
